import { AppBar, Box, Chip, Toolbar, Typography } from "@mui/material";
import { MissingField } from "../models/eaf.models";

interface Props {
  missingFields: MissingField[];
}

export const MissingFieldsBanner = ({ missingFields }: Props) => {
  if (!missingFields || missingFields.length === 0) return null;

  return (
    <AppBar
      position="static"
      style={{ backgroundColor: "#f9f871" }}
      key={`missing-fields-banner-${missingFields.length}`}
    >
      <Toolbar sx={{ flexWrap: "wrap", gap: 1 }}>
        <Typography variant="h6" style={{ color: "#000" }}>
          You have {missingFields.length} missing field
          {missingFields.length > 1 ? "s" : ""}:
        </Typography>
        <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
          {missingFields.map((f) => (
            <Chip
              key={f.FieldName}
              label={f.DisplayName}
              size="small"
              style={{
                backgroundColor: "#fff",
                color: "#000",
                fontWeight: 500,
              }}
            />
          ))}
        </Box>
      </Toolbar>
    </AppBar>
  );
};
